import Ajax from '../../util/ajax';
export function zigbeeAttributeSet(nid, eid, cid, dir, aid, a) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/' + cid + '/' + dir + '/attribute/' + aid;
        ajax.post(url, a);
    };
}
